import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Buttons, Reference, Field } from '~/form'
import { Map, List, fromJS } from 'immutable'
import { Button, Popup, Icon } from 'semantic-ui-react'
const { Group: ButtonGroup } = Button
import moment from 'moment'
import DateTime from 'react-datetime'

/**
 * Filter group
 */

class DataTableFilterGroup extends Component {
  renderForm = () => {
    let { filters, fields, onChange } = this.props

    return (
      <div className="ui form datatable-filter-group-inner">
        {fields.map(({ name, type, label, referenceConfig, options = [], multiple = false } = {}, key) => {
          let value = filters[name] || false
          return (
            <Field
              label={label}
              name={name}
              type={type}
              value={value}
              inputType="list"
              referenceConfig={referenceConfig}
              options={options}
              key={key}
              onChange={onChange}
            />
          )
        })}
      </div>
    )
  }

  emptyFilter = () => {
    let { fields, onChange, filters } = this.props

    for (let field of fields) {
      if (filters[field.name]) delete filters[field.name]
    }
    onChange(filters)
  }

  render() {
    let { icon, placeholder, filters, fields } = this.props
    let content = placeholder

    let filterCount = fields.reduce((count, { name }) => {
      if (filters[name]) count++

      return count
    }, 0)

    if (filterCount) content = `${content} (${filterCount})`

    return (
      <div className="datatable-filter-group">
        <ButtonGroup>
          <Popup
            trigger={<Button icon={icon} content={content} size="tiny" />}
            content={this.renderForm()}
            style={{ margin: 0, padding: 0, borderRadius: 0 }}
            on="click"
            position="bottom left"
          />
          {filterCount ? (
            <Button icon="times" onClick={e => e.preventDefault() & this.emptyFilter()} size="tiny" />
          ) : null}
        </ButtonGroup>
      </div>
    )
  }
}

/**
 * Date range
 */

class DataTableFilterDateRange extends Component {
  state = {
    open: false,
    startDate: false,
    endDate: false,
  }

  setDate = (type, date) => {
    let { startDate, endDate } = this.state

    let stateUpdate = {
      [type]: date,
    }

    if (type === 'startDate' && date.isAfter(endDate)) stateUpdate.endDate = date.add(1, 'days')

    if (type === 'endDate' && date.isBefore(startDate)) stateUpdate.startDate = date.subtract(1, 'days')

    this.setState(stateUpdate)
  }

  updateDates = () => {
    let { onChange } = this.props
    let { startDate, endDate } = this.state
    onChange([startDate.valueOf(), endDate.valueOf()])
    this.setState({
      open: false,
    })
  }

  componentDidUpdate = (prevProps, { open: prevOpen }) => {
    let { open, startDate, endDate } = this.state
    let { value = [] } = this.props
    if ((!startDate && !endDate) || (open && !prevOpen)) {
      let stateUpdate = {}

      if (!startDate) {
        let startValue = parseInt(value[0])
        if (!isNaN(startValue)) {
          stateUpdate.startDate = moment(startValue)
        } else {
          stateUpdate.startDate = moment().startOf('day')
        }
      }

      if (!endDate) {
        let endValue = parseInt(value[1])
        if (!isNaN(endValue)) {
          stateUpdate.endDate = moment(endValue)
        } else {
          stateUpdate.endDate = moment().add('1', 'months').endOf('day')
        }
      }

      if (Object.keys(stateUpdate).length) this.setState(stateUpdate)
    }
  }

  renderForm = () => {
    let { open, startDate, endDate } = this.state
    let { value = [] } = this.props

    if (!open) return null

    return (
      <div className="datatable-filter-date-range">
        <div className="datatable-filter-date-range-inputs">
          <DateTime value={startDate} open={true} onChange={m => this.setDate('startDate', m)} />
          <DateTime value={endDate} open={true} onChange={m => this.setDate('endDate', m)} />
        </div>
        <div className="datatable-filter-date-range-action">
          <Button content="Käytä" color="green" size="tiny" onClick={e => e.preventDefault() & this.updateDates()} />
        </div>
      </div>
    )
  }

  render() {
    let { open, startDate, endDate } = this.state
    let { content = 'Custom', active, value = [] } = this.props

    if (active) {
      try {
        content = `${moment(parseInt(value[0])).format('D.M.')} - ${moment(parseInt(value[1])).format('D.M.')}`
      } catch (err) {
        console.log(err)
      }
    }

    return (
      <Popup
        trigger={<Button content={content} size="tiny" active={active} />}
        content={this.renderForm()}
        style={{ margin: 0, padding: 0, borderRadius: 0 }}
        on="click"
        open={open}
        onOpen={() => this.setState({ open: true })}
        onClose={() => this.setState({ open: false })}
        position="bottom left"
      />
    )
  }
}

/**
 * Dates
 */

const dateButtons = [
  {
    label: 'Suunnitteilla',
    value: 'planned',
  },
  {
    label: 'Myöhässä',
    value: 'late',
  },
  {
    label: 'Tänään',
    value: 'today',
  },
  {
    label: 'Huomenna',
    value: 'tomorrow',
  },
  {
    label: 'Tällä viikolla',
    value: 'thisweek',
  },
  {
    label: 'Ensi viikolla',
    value: 'nextweek',
  },
  {
    label: 'Ei asetettu',
    value: 'empty',
  },
]

class DataTableFilterDates extends Component {
  render() {
    let { name, filters, onChange } = this.props

    let value = filters[name] || []
    let customValue = []
    let customLabel = 'Custom'

    if (value.length > 1) {
      customValue = value
      value = 'custom'
    } else {
      value = value[0]
    }

    return (
      <div className="datatable-filter-dates">
        <ButtonGroup>
          {dateButtons.map(({ value: buttonValue, label }, key) => (
            <Button
              content={label}
              key={key}
              active={value === buttonValue}
              size="tiny"
              onClick={e => e.preventDefault() & onChange({ name, value: buttonValue })}
            />
          ))}
          <DataTableFilterDateRange
            active={value === 'custom'}
            content={customLabel}
            value={customValue}
            onChange={dates => onChange({ name, value: dates })}
          />
          {value ? (
            <Button icon="times" onClick={e => e.preventDefault() & onChange({ name, value: false })} size="tiny" />
          ) : null}
        </ButtonGroup>
      </div>
    )
  }
}

/**
 * Filter bar
 */

export default class DataTableFilterBar extends Component {
  updateFilters = e => {
    let { filters, onChange } = this.props
    let { name, value } = e.target || e || {}
    let currentValue = filters[name] || []

    if (List.isList(value)) value = value.toJS()

    if (!Array.isArray(currentValue)) currentValue = []

    if (Array.isArray(value)) {
      currentValue = value
    } else if (value) {
      if (currentValue.indexOf(value) > -1) {
        currentValue = []
      } else {
        currentValue = [value]
      }
    } else {
      currentValue = []
    }

    if (currentValue.length) {
      filters[name] = currentValue
    } else {
      delete filters[name]
    }

    onChange(filters)
  }

  render() {
    let { filterFields = [], filtersString, filters, onChange } = this.props

    return (
      <div className="datatable-filters">
        <div
          className={`datatable-filters-label ${Object.keys(filters).length ? 'datatable-filters-label--active' : ''}`}>
          <Icon name="filter" />
        </div>
        {filterFields.map((data, key) => {
          let { name, type, loading, options, referenceConfig, fields, multiple = false } = data || {}

          let filterValue = filters[name] || []
          return (
            <div className="datatable-filter" key={key}>
              {type === 'buttons' ? (
                <Buttons
                  name={name}
                  value={fromJS(filterValue || [])}
                  options={options}
                  onChange={this.updateFilters}
                  multiple={multiple}
                  color={false}
                  size="tiny"
                />
              ) : type === 'group' ? (
                <DataTableFilterGroup {...data} filters={filters} onChange={this.updateFilters} />
              ) : type === 'dates' ? (
                <DataTableFilterDates {...data} filters={filters} onChange={this.updateFilters} />
              ) : (
                <div>
                  Filter
                  {type} not found
                </div>
              )}
            </div>
          )
        })}
      </div>
    )
  }
}
